import Typography from '@cobliteam/ui/components/Typography';

import { cn } from '@cobliteam/ui/utils';
import type React from 'react';
import type { ComponentProps } from 'react';

interface DataTableCellBaseWithContent {
  title?: never;
  titleAlt?: string;
  onClick?: () => void;
  subtitle?: never;
  disableTitle?: boolean;
  disableSubtitle?: boolean;
  content: string | React.ReactNode;
  color?: ComponentProps<typeof Typography>['color'];
  colorSubtitle?: ComponentProps<typeof Typography>['color'];
  align?: 'left' | 'center' | 'right';
  className?: string;
}

interface DataTableCellBaseWithTitle {
  title: string;
  titleAlt?: string;
  subtitle?: string;
  disableTitle?: boolean;
  disableSubtitle?: boolean;
  content?: never;
  onClick?: () => void;
  align?: 'left' | 'center' | 'right';
  className?: string;
  color?: ComponentProps<typeof Typography>['color'];
  colorSubtitle?: ComponentProps<typeof Typography>['color'];
}

export type DataTableProps = DataTableCellBaseWithContent | DataTableCellBaseWithTitle;

const DataTableCell = ({ title, titleAlt, onClick, subtitle, disableTitle, disableSubtitle, color, colorSubtitle, content, align = 'left', className }: DataTableProps) => {
  if (content && typeof content === 'object') return content;

  if (content && typeof content !== 'object')
    return (
      <Typography
        onClick={onClick}
        color={color || 'secondary'}
        title={disableTitle ? undefined : titleAlt || title}
        className={cn(
          'line-clamp-1',
          onClick ? 'cursor-pointer text-primary-9 hover:underline' : 'cursor-default',
          align === 'right' && 'text-right',
          align === 'center' && 'text-center',
          className
        )}
      >
        {content}
      </Typography>
    );

  return (
    <div className={cn('flex flex-col gap-1', align === 'right' && 'text-right')}>
      <Typography
        title={disableTitle ? undefined : titleAlt || title}
        color={color || 'secondary'}
        onClick={onClick}
        variant='description-title'
        className={cn('line-clamp-1', onClick ? 'cursor-pointer text-primary-9 hover:underline' : 'cursor-default', align === 'right' && 'text-right', className)}
      >
        {title}
      </Typography>

      {subtitle ? (
        <Typography
          color={colorSubtitle || 'secondary'}
          title={disableSubtitle ? undefined : subtitle}
          variant='caption-default'
          className={cn('line-clamp-1', align === 'right' && 'text-right')}
        >
          {subtitle}
        </Typography>
      ) : null}
    </div>
  );
};

export default DataTableCell;
